var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-con"},[_c('Card',{attrs:{"icon":"log-in","title":"欢迎登录"}},[_c('div',{staticClass:"form-con"},[_c('login-form',{attrs:{"loading":_vm.loading},on:{"on-success-valid":_vm.handleSubmit}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }